import { render, staticRenderFns } from "./PlanSemanalPage.vue?vue&type=template&id=767d5290"
import script from "./PlanSemanalPage.vue?vue&type=script&lang=js"
export * from "./PlanSemanalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports